"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CustomReactMarkdown = _interopRequireDefault(require("../../../../shared/components/MarkdownRenderers/CustomReactMarkdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AddOns = function AddOnsComponent(_ref) {
  var options = _ref.options;
  var titles = options.reduce(function (addOnElements, _ref2) {
    var addOn = _ref2.addOn;

    if (addOn) {
      var checked = addOn.checked,
          title = addOn.content.title;

      if (checked) {
        addOnElements.push( /*#__PURE__*/_react["default"].createElement("span", {
          className: "order-items__attribute-value",
          key: title
        }, /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
          source: title,
          noWrapper: true
        })));
      }
    }

    return addOnElements;
  }, []);
  return titles.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "order-items__attribute"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "order-items__attribute-key"
  }, "Exclusive Offers"), titles);
};

AddOns.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var _default = AddOns;
exports["default"] = _default;